import { DeliveryEntity } from "../../Objects/DeliveryEntity/DeliveryEntity"
import { EDeliveryStatusType } from "../../Enum/EDeliveryStatusType"
import { useSaveDelivery } from "../../hooks/Delivery/useSaveDelivery"
import { CourierDeliveryCard } from "./Components/CourierDeliveryCard"
import { CourierRoutePlanBanner } from "./Components/CourierRoutePlanBanner"
import { useTranslation } from "react-i18next"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"

interface CourierPanelPageProps {
  deliveries: DeliveryEntity[]
  onOpenRoutePlan: () => void
}

export function CourierPanelPage({ deliveries, onOpenRoutePlan }: CourierPanelPageProps) {
  const { t } = useTranslation("frontend")

  const { handleUpdateDeliveryStatus } = useSaveDelivery()


  const handleStatusUpdate = async (deliveryId: number, status: EDeliveryStatusType) => {
    handleUpdateDeliveryStatus(deliveryId, status, () => {})
  }

  const handleCancelDelivery = async (deliveryId: number) => {
    handleUpdateDeliveryStatus(deliveryId, EDeliveryStatusType.Canceled, () => {})
  }


  return (
    <div className="min-h-screen space-y-3.5 p-1">
      <CourierRoutePlanBanner deliveries={deliveries} onOpen={onOpenRoutePlan} />

      <div className="space-y-3">
        {deliveries.length === 0 && (
          <Animate type={AnimationTypes.fadeInTraslate}>
            <div className="p-4 text-center text-sm font-bold text-slate-500">
              {t("courier_panel.empty_deliveries")}
            </div>
          </Animate>
        )}

        {deliveries.map((item: DeliveryEntity) => (
          <CourierDeliveryCard
            key={item.id}
            delivery={item}
            onUpdateStatus={handleStatusUpdate}
            onCancelDelivery={handleCancelDelivery}
          />
        ))}
      </div>
    </div>
  )
}
